import { Platform } from '@angular/cdk/platform';
import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { Show } from "../interfaces/show.interface";
import { environment } from "../../environments/environment";
import { duration } from 'moment';
import { BrandDataService } from './brand-data.service';

@Injectable({
    providedIn: 'root'
})
export class SupportService {
    
    
    constructor(
        private http: HttpClient, 
        private brandDataService: BrandDataService) {}

    


    // GET the ALL User Data 'API';
    getUserDataListing(page: number, limit: number, sortField: string, sortDirection: string): Observable<any> {
        return this.http.get(`${environment.apiUrl}/users/user-data/list`, {
            params: {
                page: page.toString(),
                limit: limit.toString(),
                sort: sortField,
                direction: sortDirection
            }
        });
    }


    getGrantStatus(): Observable<Object> {
        return this.http.get(environment.apiUrl + '/support/impersonate/status/');
    }

    grantSupport(duration: number | null): Observable<Object> {
        const brandData = this.brandDataService.getBrandPayload();

        const payload = {
            duration:duration,
            siteName: brandData?.siteName,
            domainUrl: brandData?.domainUrl,
            imageUrl:brandData?.imageUrl,
            color:brandData?.color
        } 
        return this.http.post(environment.apiUrl + '/support/impersonate/grant/', payload );

    }

    revokeSupport(): Observable<Object> {
        return this.http.post(environment.apiUrl + '/support/impersonate/revoke/', {});

    }

    impersonate(userId: string | number): Observable<Object> {
        return this.http.post(environment.apiUrl + `/admin/users/${userId}/impersonate`, {});
    }

    getSessionsHistory(page:number, limit:number): Observable<Object> {
        return this.http.get(environment.apiUrl + `/admin/sessions?page=${page}&limit=${limit}`)
    }

    getSessionLogs(sessionId:string | number, page: number, limit: number): Observable<Object> {
        return this.http.get(environment.apiUrl + `/admin/sessions/${sessionId}/logs?page=${page}&limit=${limit}`)
    }

}